import { fieldsConnect } from "@/locale/modules/index";
import common from "@/locale/modules/common";

const user = {
  Mailbox: ["邮箱号", "Mail"],
  Organization: ["组织", "Organization"],
  AuthenticateStatus: ["认证状态", "Authenticate status"],
  MyDirectory: ["个人通讯录", "My Directory"],
  CorporateDirectory: ["企业通讯录", "Corporate Directory"],
  PleaseEnterMobile: fieldsConnect(common, ["PleaseEnter", "Mobile"]),
  PleaseEnterName: fieldsConnect(common, ["PleaseEnter", "Name"]),
  Profile: ["个人设置", "Profile"],
  BasicInformation: ["基本信息", "Basic Information"],
  SignatureAndSeal: ["签名签章", "Signature and Seal"],
  OrganizationAndRole: ["组织角色", "Organization and Role"],
  Edit: ["修改", "Edit"],
  Name: ["真实姓名", "Name"],
  IdentityNumber: ["身份证号", "Identity Number"],
  Nickname: ["昵称", "Nickname"],
  NicknameTip: [
    "登录账号，平台唯一，可修改",
    "Nickname is Platform Unique and can be Modified",
  ],
  NameVerified: fieldsConnect(common, [["实名", "Name"], "Space", "Verified"]),
  NameNotVerified: fieldsConnect(common, [
    ["实名", "Name"],
    "Space",
    "NotVerified",
  ]),
  EmailVerified: fieldsConnect(common, ["Email", "Space", "Verified"]),
  EmailNotVerified: fieldsConnect(common, ["Email", "Space", "NotVerified"]),
  LoginPassword: fieldsConnect(common, ["Login", "Space", "Password"]),
  LoginPasswordTip: [
    "已设置，可通过账号密码登录",
    "Password is Setted up and can be Used to Login",
  ],
  WechatBinding: fieldsConnect(common, ["Wechat", "Space", "Binding"]),
  WechatBindingTip: [
    "已绑定，可快速扫码登录",
    "Wechat is bound for QR code Login",
  ],
  WechatUnBindingTip: [
    "未绑定，绑定后可快速扫码登录",
    "Wechat Unbound. Please Complete Binding for QR code Login",
  ],
  Enterprise: ["企业", "Enterprise"],
  Company: ["公司", "Company"],
  EnterpriseCertification: ["企业认证", "Enterprise Certification"],
  Country: ["国家", "Country"],
  Address: ["地址", "Address"],
  ModifyYourAvatar: ["修改头像", "modify your avatar"],
  DefaultPortrait: ["默认头像", "Default Portrait"],
  Customization: ["自定义", "Customization"],
  SelectLocalImage: ["选择本地图片", "Select Local Image"],
  FileUploadFormat: ["文件上传格式", "File upload format"],
  PhoneAuthTip: [
    "为保护签署的法律效力，请进行手机实名认证",
    "In order to protect the legal effect of the signature, please perform mobile phone real-name authentication",
  ],
  EmailAuthTip: [
    "请认证邮箱，认证后可用于登录",
    "Please verify the email address, which can be used to log in after authentication",
  ],
  ModifySuccessfully: ["修改成功", "Modify successfully"],
  ModifyEmailSuccessfully: ["修改邮箱成功", "Modify email successfully"],
  SendAuthEmail: [
    "发送认证邮件至绑定邮箱，请去邮箱中完成认证",
    "Send the authentication email to the bound email address, please go to the email address to complete the authentication",
  ],
  PleaseBindTheEmailFirst: ["请先绑定邮箱", "Please bind the email first"],
  Authentic: ["进行认证", "Authentic"],
  RealNameAuthentication: ["实名认证", "Real name authentication"],
  Sending: ["发送中", "Sending"],
  UnderCertification: ["认证中", "Under certification"],
  EmailNumberDoesNotExist: ["邮箱号不存在", "Email number does not exist"],
  MailHasBeenSent: ["已发送", "Mail has been sent"],
  EmailAuthenticationFailed: ["邮箱认证成功", "Email authentication failed"],
  CertificationPassed: ["认证通过", "Certification passed"],
  WeChatBindingSuccessful: ["微信绑定成功", "WeChat binding successful"],
  EmailAuthenticationSuccessful: [
    "邮箱认证失败",
    "Email authentication successful",
  ],
  ChangeYourRealNameAndIdNumber: [
    "修改真实姓名和身份证号",
    "Change your real name and ID number",
  ],
  IDNumber: ["身份证号", "ID number"],
  FirstName: ["名", "First Name"],
  LastName: ["姓", "Last Name"],
  AfterModification: ["修改后", "After modification"],
  BeforeModification: ["修改前", "Before modification"],
  PleaseEnterAModifiedFirstName: [
    "请输入修改后的姓",
    "Please enter a modified first name",
  ],
  PleaseEnterAModifiedLastName: [
    "请输入修改后的名",
    "Please enter a modified last name",
  ],
  PleaseEnterYourModifiedIdNumber: [
    "请输入修改后的身份证号",
    "Please enter your modified ID number",
  ],
  EmailAlreadyExists: ["邮箱已存在", "Email already exists"],
  CanBeModified: ["可修改", "Can be modified"],
  CannotBeModified: ["不可修改", "Cannot be modified"],
  ChangeNickname: ["修改昵称", "Change nickname"],
  OldNickname: ["旧昵称", "Old nickname"],
  NewNickname: ["新昵称", "New nickname"],
  PleaseEnterANewNickname: ["请输入新昵称", "Please enter a new nickname"],
  NicknameAlreadyExists: ["昵称已存在", "Nickname already exists"],
  ModifyMobilePhoneNumber: ["修改手机号", "Modify mobile phone number"],
  OldPhoneNumber: ["旧手机号", "Old phone number"],
  NewPhoneNumber: ["新手机号", "New phone number"],
  PleaseEnterYourNewPhoneNumber: [
    "请输入新手机号",
    "Please enter your new phone number",
  ],
  ReminderForSameMobilePhoneNumber: [
    "新手机号不能与旧手机号相同",
    "The new mobile phone number cannot be the same as the old mobile phone number",
  ],
  Vcode: ["验证码", "Vcode"],
  PleaseEnterVcode: ["请输入验证码", "Please enter Vcode"],
  Remarks: ["说明", "Remarks"],
  UpdatePhoneTip: [
    "请确保新手机号的归属人和当前账号的真实姓名一致",
    "Please make sure that the owner of the new phone number matches the real name of the current account.",
  ],
  MobilePhoneNumberAlreadyExists: [
    "手机号已存在",
    "Mobile phone number already exists",
  ],
  ModifyEmail: ["修改邮箱", "Modify email"],
  OldEmail: ["旧邮箱号", "Old email"],
  NewEmail: ["新邮箱号", "New email"],
  PleaseEnterEmail: ["请输入邮箱", "Please enter email "],
  PleaseEnterTheCorrectEmailNumber: [
    "请输入正确的邮箱号",
    "Please enter the correct email number",
  ],
  TheNewMailboxNumberCannotBeTheSameAsTheOldMailboxNumber: [
    "新邮箱号不能与旧邮箱号相同",
    "The new mailbox number cannot be the same as the old mailbox number",
  ],
  PleaseEnterTheCorrectIdNumber: [
    "请输入正确的身份证号",
    "Please enter the correct ID number",
  ],
  PleaseEnterTheCorrectModifiedLastName: [
    "请输入正确的修改后的姓",
    "Please enter the correct modified last name",
  ],
  PleaseEnterTheCorrectModifiedName: [
    "请输入正确的修改后的名",
    "Please enter the correct modified name",
  ],
  ChangeLoginPassword: ["修改登录密码", "Change login password"],
  VcodeSendingMethod: ["验证码发送方式", "Vcode sending method"],
  NewLoginPassword: ["新登录密码", "New login password"],
  PleaseEnterTheModifiedLoginPassword: [
    "请输入修改后的登录密码",
    "Please enter the modified login password",
  ],
  ModifyCountry: ["修改国家", "Modify country"],
  OldCountry: ["旧国家", "Old country"],
  NewCountry: ["新国家", "New country"],
  PleaseSelectANewCountry: ["请选择新国家", "Please select a new country"],
  ModifyAddress: ["修改地址", "Modify address"],
  OldAddress: ["旧地址", "Old address"],
  NewAddress: ["新地址", "New address"],
  PleaseEnterANewAddress: ["请输入新地址", "Please enter a new address"],
  BulkDelete: ["批量删除", "bulk delete"],
  PersonalSignatureSignature: ["个人签名/签章", "Personal signature/signature"],
  ImportSignatureSignature: ["导入签名签章", "Import signature signature"],
  Default: ["默认", "default"],
  SetAsDefault: ["设为默认", "Set as Default"],
  DrawSignature: ["绘制签名", "draw signature"],
  CorporateSignature: ["企业签章", "Corporate signature"],
  Role: ["角色", "Role"],
  NoRoleYet: ["暂无角色", "No role yet"],
  NoOrganizationYet: ["暂无所属组织", "No Organization yet"],
  DefaultSignatureFormat: ["默认签名格式", "Default signature format"],
  TheTimeIsShownBelowTheSignature: [
    "时间展示在签名下方",
    "The time is shown below the signature",
  ],
  TheTimeIsDisplayedBehindTheSignature: [
    "时间展示在签名后方",
    "The time is displayed behind the signature",
  ],
  NoSignatureYet: ["暂无签章", "No signature yet"],
  ImportSignature: ["导入签名/签章", "Import signature"],
  SignatureName: ["签名/签章名称", "Signature Name"],
  DragFilesHereOr: ["将文件拖到此处或", "Drag files here or"],
  ClickToUpload: ["点击上传", "click to upload"],
  AddedSuccessfully: ["添加成功", "Added successfully"],
  pleaseSelectTheSignatureSealToBeDeleted: [
    "请选择需要删除的签名/签章",
    "Please select the signature/seal to be deleted",
  ],
  AreYouSureYouWantToDeleteTheSelectedSignatureSeal: [
    "您确定要删除选中的签名/签章吗？",
    "Are you sure you want to delete the selected signature/seal?",
  ],
  SuccessfullyDeleted: ["删除成功", "successfully deleted"],
  SetupSuccessful: ["设置成功", "Setup successful"],
  FailToEdit: ["修改失败", "fail to edit"],
  PleaseUploadFiles: ["请上传文件", "Please upload files"],
  PleaseEnterAppellation: ["请输入名称", "Please enter name"],
  PleaseUpgradeToEnterpriseEdition: [
    "请升级到企业版",
    "Please upgrade to Enterprise Edition",
  ],
  DefaultLanguage: ["默认语言", "Default Language"],
  PleasEnterXDigitsAndACombinationOfLetters: [
    "请输入8-16位任意字符的密码",
    "Please enter 8 digits and a combination of letters (case sensitive)",
  ],
  Number: ["数字", "Number"],
  Capital: ["大写字母", "Capital"],
  LowercaseLetters: ["小写字母", "Lowercase letters"],
  SpecialCharacters: ["特殊字符", "Special Characters"],
  UpdatePasswordTip: [
    "请输入{passwordLen}位包含{passwordTip}组合的密码",
    "Please enter a password with {passwordLen} digits containing the {passwordTip} combination",
  ],
};

export default user;
